import CategoricalScheme from '../../CategoricalScheme';

const schemes = [
  {
    id: 'sparkColorsOne',
    label: 'SPARK Colors One',
    colors: [
      '#007F65',
      '#FA8C9F',
      '#BCAA97',
      '#8D88D7',
      '#445600',
      '#FFCEBD',
      '#56599F',
      '#B28520',
      '#E863FF',
      '#4C3838',
      '#DCE1F2',
      '#FF0079',
      '#567DAC',
      '#E6FC81',
      '#8D00FF',
      '#E4F7D8',
      '#9DD6FB',
      '#FDF3CD',
      '#FF5E00',
      '#8CADB6',
      '#1C6087',
      '#8A4325',
      '#30B5B3',
      '#A56C7F',
      '#F8B44A',
      '#E03437',
      '#A9CE08',
      '#6A9DF0',
      '#FF8A8C',
      '#7C1663',
    ],
  },
].map(s => new CategoricalScheme(s));

export default schemes;
